import React, {Component} from 'react';
import {
  Badge,
  Row,
  Col,
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  ListGroup, ListGroupItem, ListGroupItemHeading, ListGroupItemText,
} from 'reactstrap';
import Switch from 'react-toggle-switch';
import PropTypes from 'prop-types';
import {
	connect
} from 'react-redux';
import {
	bindActionCreators
} from 'redux';
import {
	withRouter
} from 'react-router-dom';
import {
	compose
} from 'recompose';
import Moment from 'react-moment';

import * as departureScheduleActions from '../../actions/departureScheduleActions';

// Departure Schedules
import withDepartureSchedules from '../../components/withDepartureSchedules';

// Tesla Vehicles
import withTeslaVehicles from '../../components/withTeslaVehicles';

class Schedules extends Component {
	constructor(props) {
		super(props);

		this.viewDepartureSchedule = this.viewDepartureSchedule.bind(this);
		this.addDepartureSchedule = this.addDepartureSchedule.bind(this);
		this.toggle = this.toggle.bind(this);
	}

	addDepartureSchedule(event) {
		event.preventDefault();
		this.props.history.push('/schedule/add')
	}

	viewDepartureSchedule(event) {
		event.preventDefault();
		this.props.history.push('/schedule/view/' + event.target.id)
	}

	toggle() {
		this.setState({
			collapse: !this.state.collapse
		});
	}
	
  render() {
	const authToken = this.context.authToken;
	const actions = this.props.actions;
	
	var vehicles = {};
	var isShowVehicleName = this.context.teslaVehicles.length > 1;
	for (var i = 0; i < this.context.teslaVehicles.length; i++) {
		var vehicle = this.context.teslaVehicles[i];
		vehicles[vehicle.vehicleId] = vehicle.displayName;
	}

	var temperatureUnit = this.context.preferences.temperatureUnit;
	if (temperatureUnit == null) {
		temperatureUnit = "fahrenheit"
	}
	
    var newestLastUpdated = null;
    return (
      <div className="animated fadeIn">
        <Row>
          <Col>
            <Card>
              <CardHeader>
                <i className="fa fa-align-justify"></i> Schedule
			    <div className="card-actions">
			      <a href="/schedule/add" onClick={this.addDepartureSchedule}>
					<small className="text-muted">+ Add</small>
				  </a>
			    </div>
              </CardHeader>
              <CardBody>
				<Row>
					<Col>
						<p>Select a schedule to view and edit details. Select "+ Add" above to add a schedule.</p>
					</Col>
				</Row>
				<Row>
					<Col>
		                <ListGroup>
						  {this.context.departureSchedules.map(departureSchedule => {
							  if (departureSchedule.deleted) {
								  return null;
							  }
							  
							  var temperatureStr = "";
							  
							  var temperatureInC;
							  if (departureSchedule.temperatureInC != null) {
							    temperatureInC = Number.parseFloat(departureSchedule.temperatureInC);
							  }
	
							  if (temperatureInC != null) {
							      if (temperatureUnit == "fahrenheit") {
							  	      // Round to nearest fahrenheit degree
							  	      temperatureStr = Math.round((temperatureInC * 9.0 / 5.0) + 32.0) + "F";
							      } else if (temperatureUnit == "celsius") {
							  	      // Round to nearest celsius half-degree
							  	      temperatureStr = (Math.round(temperatureInC * 2.0) / 2.0).toFixed(1) + "C";
							      }
							  }
							  
							  if (departureSchedule.type === 'soon') {
									  return (			  						  
				                  		  <ListGroupItem key={departureSchedule.id}>
										  <VehicleName show={isShowVehicleName} displayName={vehicles[departureSchedule.vehicleId]}/>Soon {temperatureStr}
										  </ListGroupItem>
									  );
							  } else if (departureSchedule.type === 'once') {
								  return (
			                  		  <ListGroupItem action key={departureSchedule.id} id={departureSchedule.id} onClick={this.viewDepartureSchedule}>
									  <Switch id={'enableDisable-' + departureSchedule.id} name={'enableDisable-' + departureSchedule.id} onClick={function(event) { enableDisableState(departureSchedule, authToken, actions); }} on={departureSchedule.enabled} /> <VehicleName show={isShowVehicleName} displayName={vehicles[departureSchedule.vehicleId]}/><Moment format='LLLL'>{departureSchedule.onceTime}</Moment> {temperatureStr}
									  </ListGroupItem>
								  );
							  } else if (departureSchedule.type === 'recurring') {
								  var daysStr = '';
								  
								  if (departureSchedule.recurringDaysOfWeek.includes("sunday")
							  		&& departureSchedule.recurringDaysOfWeek.includes("monday")
							  		&& departureSchedule.recurringDaysOfWeek.includes("tuesday")
							  		&& departureSchedule.recurringDaysOfWeek.includes("wednesday")
							  		&& departureSchedule.recurringDaysOfWeek.includes("thursday")
							  		&& departureSchedule.recurringDaysOfWeek.includes("friday")
									&& departureSchedule.recurringDaysOfWeek.includes("saturday")) {
										daysStr = 'Everyday';
								} else if (departureSchedule.recurringDaysOfWeek.includes("monday")
							  		&& departureSchedule.recurringDaysOfWeek.includes("tuesday")
							  		&& departureSchedule.recurringDaysOfWeek.includes("wednesday")
							  		&& departureSchedule.recurringDaysOfWeek.includes("thursday")
									&& departureSchedule.recurringDaysOfWeek.includes("friday")) {
										daysStr = 'Weekdays';
								} else if (departureSchedule.recurringDaysOfWeek.includes("sunday")
									&& departureSchedule.recurringDaysOfWeek.includes("saturday")) {
										daysStr = 'Weekends';
								} else {
									for (var i = 0; i < departureSchedule.recurringDaysOfWeek.length; i++) {
										if (daysStr !== '') {
											daysStr += ", "
										}
										var dayStr = departureSchedule.recurringDaysOfWeek[i];
										switch (dayStr) {
										case "sunday":
											daysStr += "Sundays";
											break;
											
										case "monday":
											daysStr += "Mondays";
											break;
											
										case "tuesday":
											daysStr += "Tuesdays";
											break;
											
										case "wednesday":
											daysStr += "Wednesdays";
											break;
											
										case "thursday":
											daysStr += "Thursdays";
											break;
											
										case "friday":
											daysStr += "Fridays";
											break;
											
										case "saturday":
											daysStr += "Saturdays";
											break;
											
										default:
											break;
										}
									}
								}
								
								  return (
			                  		  <ListGroupItem action key={departureSchedule.id} id={departureSchedule.id} onClick={this.viewDepartureSchedule}>
									  <Switch id={'enableDisable-' + departureSchedule.id} name={'enableDisable-' + departureSchedule.id} onClick={function(event) { enableDisableState(departureSchedule, authToken, actions); }} on={departureSchedule.enabled} /> <VehicleName show={isShowVehicleName} displayName={vehicles[departureSchedule.vehicleId]}/><Moment parse='HH:mm' format='h:mm a'>{departureSchedule.recurringHour}:{departureSchedule.recurringMinute}</Moment> {daysStr} {temperatureStr}
									  </ListGroupItem>
								  );
							  }
						  })}
		                </ListGroup>
					</Col>
				</Row>
              </CardBody>
  			  <CardFooter>
  			  </CardFooter>
            </Card>
          </Col>
        </Row>
      </div>

    )
  }
}

function VehicleName(props) {
	if (!props.show) {
		return null;
	}
	
  	return (
  		<span><strong>{props.displayName}</strong> </span>
  	);
}

function enableDisableState(departureSchedule, authToken, actions) {
	departureSchedule.enabled = !departureSchedule.enabled;
	
	actions.updateDepartureSchedule('deviceId', authToken, departureSchedule);
}

function mapStateToProps(state, ownProps) {
	return {};
}

function mapDispatchToProps(dispatch) {
	return {
		actions: bindActionCreators(departureScheduleActions, dispatch)
	}
}

Schedules.contextTypes = {
	authToken: PropTypes.string.isRequired,
	departureSchedules: PropTypes.array.isRequired,
	teslaVehicles: PropTypes.array.isRequired,
	preferences: PropTypes.object.isRequired
}

Schedules.propTypes = {
	actions: PropTypes.object.isRequired,
};

export default compose(
	connect(mapStateToProps, mapDispatchToProps),
	withRouter,
	withTeslaVehicles,
	withDepartureSchedules
)(Schedules);



// WEBPACK FOOTER //
// ./src/views/Schedules/Schedules.js